<template>
	<button
		type="button"
		v-bind="$attrs"
		:class="buttonClass"
	>
		<slot name="prefix">
			<AppIcon
				v-if="icon"
				fixed-width
				:class="{ 'ml-1 mr-2': !iconOnly }"
				:icon="icon"
				:beat="beat"
				:bounce="bounce"
				:spin="spin"
			/>
		</slot>
		<span><slot/></span>
		<slot name="suffix"/>
	</button>
</template>

<script setup lang="ts">
type ButtonProps = {
	icon?: string | string[];
	iconOnly?: boolean;
	size?: "xs" | "sm" | "md" | "lg" | "xl";
	color?: "primary" | "secondary" | "accent" | "success" | "danger" | "warning" | "info";
	variant?: "solid" | "outline" | "ghost";
	rounded?: "pill" | "rounded" | "none";
	addon?: boolean;
	beat?: boolean;
	bounce?: boolean;
	spin?: boolean;
};

const props = withDefaults(defineProps<ButtonProps>(), {
	size: "md",
	color: "primary",
	variant: "solid",
	rounded: "rounded",
	addon: false,
	beat: false,
	bounce: false,
	spin: false,
});

// const buttonColor = computed(() => {
//   return `var(--color-${props.color})`;
// });

const buttonClass = computed(() => {
	return [
		"c-btn",
		`${props.color}`,
		`${props.size}`,
		`${props.variant}`,
		`c-btn--${props.rounded}`,
		{ addon: props.addon },
		{ "icon-only": props.iconOnly },
	];
});
</script>

<style scoped>
</style>
